// extracted by mini-css-extract-plugin
export default {"modalOverlay":"MJ-z","modalContent":"NJ-z","header":"OJ-z","close":"PJ-z"};